import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = {
  key: 0,
  class: "app-modal__loader"
}
const _hoisted_3 = ["innerHTML"]

import BaseGridCol from '@/components/BaseGridCol.vue';
import {
  ref,
  computed,
} from 'vue';
import ClickWrapper from '@/components/ClickWrapper.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSpinner } from '@fortawesome/pro-light-svg-icons';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
    headline: {},
    closeable: { type: Boolean, default: true },
    small: { type: Boolean },
    large: { type: Boolean },
    loading: { type: Boolean },
    plain: { type: Boolean },
    hideClose: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

library.add(faSpinner, faXmark);

const emit = __emit;

const props = __props;

const show = ref(false);
const fadeIn = ref(false);
const fadeOut = ref(false);

const classes = computed(() => ({
  'app-modal': true,
  open: fadeIn.value || show.value || fadeOut.value,
  shown: show.value,
  small: props.small,
  large: props.large,
}));

const open = () => {
  fadeIn.value = true;
  setTimeout(() => {
    show.value = true;
  }, 25);
  setTimeout(() => {
    fadeIn.value = false;
  }, 680);
};

const close = () => {
  fadeOut.value = true;
  show.value = false;
  setTimeout(() => {
    fadeOut.value = false;
  }, 680);

  if (props.closeable) {
    emit('close');
  }
};

const onClickOutside = () => {
  if (props.closeable) {
    close();
  }
};

__expose({
  open,
  close,
});

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_BaseGridRow = _resolveComponent("BaseGridRow")!

  return (show.value || fadeOut.value || fadeIn.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([classes.value, "d-print-none"])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(ClickWrapper, {
            class: "io-modal__container",
            ref: "root",
            onOutside: onClickOutside
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["app-modal__card", {
              plain: _ctx.plain,
            }])
              }, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_FontAwesomeIcon, {
                          icon: "fa-light fa-spinner",
                          class: "fa-pulse"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_BaseGridRow, null, {
                  default: _withCtx(() => [
                    (_ctx.headline)
                      ? (_openBlock(), _createBlock(BaseGridCol, {
                          key: 0,
                          class: "app-modal__card__headline"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", { innerHTML: _ctx.headline }, null, 8, _hoisted_3)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(BaseGridCol, null, {
                      default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "default")
                      ]),
                      _: 3
                    })
                  ]),
                  _: 3
                }),
                (!_ctx.hideClose)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "close close-absolute font-h4",
                      onClick: close
                    }, [
                      _createVNode(_component_FontAwesomeIcon, { icon: "fa-regular fa-xmark" })
                    ]))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            _: 3
          }, 512)
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})